import React from "react";
import { escape2Html } from "../../util";
import "../../style/index.less";

import WeaLocaleProvider from "../../../../ecology9/wea-locale-provider";
const getLabel = WeaLocaleProvider.getLabel;

class SingleMessage extends React.Component {
  render() {
    const bizstateEnum = {
      "1": getLabel("1454", "已处理"),
      "34": getLabel("129265", "已暂停"),
      "35": getLabel("1981", "已撤销"),
      "27": getLabel("18967", "已删除")
    };
    return (
      <div className="wea-messageCenter-singleItem">
        <p className="wea-messageCenter-singleItem-time">{this.props.time}</p>
        {this.props.showimage && (
          <div
            style={{ backgroundImage: `url(${this.props.showimage})` }}
            className="wea-messageCenter-singleItem-image"
          />
        )}
        <div
          className="wea-messageCenter-singleItem-content"
          onClick={() => {
            if (this.props.bodyLink) {
              if (window.em && window.localStorage.emobile_ec_id) {
                window.em.checkJsApi("openLink") &&
                  window.em.openLink({
                    url: this.props.link,
                    openType: 2,
                    sysId: window.localStorage.emobile_ec_id,
                    error: function(error) {
                      alert(JSON.stringify(error));
                    }
                  });
                !window.em.checkJsApi("openLink") &&
                  window.open(this.props.link);
              } else {
                window.open(this.props.link);
              }
            }
          }}
        >
          <div className="wea-messageCenter-singleItem-title wea-f14">
            {" "}
            {this.props.name}{" "}
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: escape2Html(this.props.title)
            }}
            // title={escape2Html(this.props.title)}
            className="wea-messageCenter-singleItem-detail wea-f12"
          />
          {this.props.context && (
            <div className="wea-messageCenter-singleItem-creator wea-f12">
              <p
                dangerouslySetInnerHTML={{
                  __html: escape2Html(
                    this.props.context.replace(/<img[^>]+>/gi, "[图片]")
                  )
                }}
              />
            </div>
          )}
          {Object.keys(bizstateEnum).includes(this.props.bizstate) && (
            <div className="wea-messageCenter-singleItem-handled-tag">
              <i>{bizstateEnum[this.props.bizstate]}</i>
            </div>
          )}
          {this.props.link && (
            <a
              // target="_blank"
              className="wea-messageCenter-singleItem-a"
              // href={`${this.props.link}`}
              onClick={() => {
                if (this.props.bodyLink) {
                  return;
                }
                if (window.em && window.localStorage.emobile_ec_id) {
                  window.em.checkJsApi("openLink") &&
                    window.em.openLink({
                      url: this.props.link,
                      openType: 2,
                      sysId: window.localStorage.emobile_ec_id,
                      error: function(error) {
                        alert(JSON.stringify(error));
                      }
                    });
                  !window.em.checkJsApi("openLink") &&
                    window.open(this.props.link);
                } else {
                  window.open(this.props.link);
                }
              }}
            >
              <div className="wea-messageCenter-singleItem-more wea-f12">
                {getLabel("503547", "阅读详情")}
                <span className="wea-messageCenter-singleItem-moreIcon">
                  &gt;
                </span>
              </div>
            </a>
          )}
        </div>
      </div>
    );
  }
}
export default SingleMessage;



// WEBPACK FOOTER //
// ./comMobx/wea-message-center/components/message-center/singleMessage.js